import TextInput from "./text-input";
import PasswordInput from "./password-input";
import DateInput from "./date-input/DateInput";
import AutoCompleteInput from "./auto-complete-input";
import LeadActivityAutoCompleteInput from "./lead-activity-autocomplete-input";
import SalesPersonsAutoCompleteInput from "./sales-persons-auto-complete-input";
import VisibilityGroupInput from "./visibility-group-input";
import VersionAutoCompleteInput from "./version-autocomplete";

export default {
  TextInput,
  PasswordInput,
  DateInput,
};

export {
  TextInput,
  PasswordInput,
  DateInput,
  AutoCompleteInput,
  LeadActivityAutoCompleteInput,
  SalesPersonsAutoCompleteInput,
  VisibilityGroupInput,
  VersionAutoCompleteInput,
};
